import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 35AAECBA-CF24-4DCC-99F0-20D9CB21B58B
 * name distribute-vertical-center
 * version: 4.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/distribute-vertical-center.svg
 * tags
 */
export const DistributeVerticalCenterIcon = createSvgIcon(<><path d="M2 16H5V14H19V16H22V18H19V20H5V18H2V16M2 8H7V10H17V8H22V6H17V4H7V6H2V8Z" /></>, 'DistributeVerticalCenterIcon');
export default DistributeVerticalCenterIcon